<div style="display: flex; justify-content: space-between; align-items: center;">

  <h2 mat-dialog-title style="font-weight: bolder;">User Trips: {{ data.dbName }}</h2>

  <button mat-mini-fab
    (click)="dialogRef.close()"
    style="background-color: #005d87; color: white; font-weight: bold; margin-right: 10px;">
    <mat-icon>close</mat-icon>
  </button>

</div>


<mat-dialog-content>
  @if (trips.length > 0) {
    <mat-accordion>
      @for (doc of trips; track trackByDocId($index, doc)) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ doc.trip.startFishingReport.startDate | date:'mediumDate' }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (rpt of doc.reports; track trackByReportId($index, rpt)) {
            <div class="report-row">
              <div class="report-type">Report Type: {{ rpt.reportType }}</div>
              <div class="report-date">Date: {{ rpt.date | date:'short' }}</div>
              <div>Report ID: {{ rpt.reportID }}</div>
              <mat-form-field appearance="outline" class="report-confirm">
                <mat-label>Confirmation #</mat-label>
                <input matInput [(ngModel)]="rpt.confirmationNumber">
              </mat-form-field>
            </div>
          }
          <mat-action-row>
            <button mat-stroked-button
              style="background-color: #ff6f61; color: white; font-weight: bold;"
              [disabled]="savingConfirmation"
              (click)="saveTrip(doc)">
              @if (savingConfirmation) {<mat-spinner [diameter]="30"></mat-spinner>} @else {Save}
            </button>
          </mat-action-row>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

  @if (!loadingTrips && trips.length === 0) {
    <p>No trips found for this user.</p>
  }
  @if (loadingTrips) {
    <p>Loading trips...</p>
  }
  @if (loadingTrips) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-content>